// Global Recent Views Tracking
// Extracted from layout/theme.liquid 2026-05-20 for performance:
// loading via <script defer src="..."> is faster than parse-blocking inline JS.
(function() {
  const RECENT_VIEWS_KEY = 'shopify_recent_views';
  const MAX_RECENT_ITEMS = 20;

  // Function to get recent views from localStorage
  function getRecentViews() {
    try {
      const stored = localStorage.getItem(RECENT_VIEWS_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }

  // Function to save recent views to localStorage
  function saveRecentViews(views) {
    try {
      localStorage.setItem(RECENT_VIEWS_KEY, JSON.stringify(views));
    } catch (e) {
      console.warn('Could not save recent views to localStorage');
    }
  }

  // Function to add current product to recent views
  function addToRecentViews(productHandle, productData) {
    if (!productHandle) return;

    let recentViews = getRecentViews();

    // Remove if already exists
    recentViews = recentViews.filter(item => item.handle !== productHandle);

    // Add to beginning with extended data
    recentViews.unshift({
      handle: productHandle,
      title: productData.title || '',
      url: productData.url || `/products/${productHandle}`,
      image: productData.image || '',
      price: productData.price || '',
      vendor: productData.vendor || '',
      badges: productData.badges || [],
      reviewData: productData.reviewData || null,
      timestamp: Date.now()
    });

    // Keep only recent items
    recentViews = recentViews.slice(0, MAX_RECENT_ITEMS);

    saveRecentViews(recentViews);
  }

  // Auto-track current product if on product page
  if (window.location.pathname.includes('/products/')) {
    const productHandle = window.location.pathname.split('/products/')[1].split('?')[0];

    if (productHandle) {
      // Function to capture and save product data
      function captureProductData() {
        // Get badge data from inside product-information__media
        const mediaContainer = document.querySelector('.product-information__media');
        const badgeElements = mediaContainer ? mediaContainer.querySelectorAll('.delivery-badge-block .delivery-badge') : [];
        const badges = [];
        badgeElements.forEach(badge => {
          const img = badge.querySelector('.delivery-badge__image');
          const text = badge.querySelector('.delivery-badge__text');
          if (img || text) {
            badges.push({
              image: img ? img.src : '',
              name: text ? text.textContent.trim() : ''
            });
          }
        });

        // Get Judge.me review data from the badge element
        const reviewBadge = document.querySelector('.jdgm-preview-badge .jdgm-prev-badge');
        let reviewData = null;
        if (reviewBadge) {
          const rating = reviewBadge.getAttribute('data-average-rating');
          const reviewCount = reviewBadge.getAttribute('data-number-of-reviews');
          if (rating && reviewCount) {
            reviewData = {
              rating: parseFloat(rating),
              count: parseInt(reviewCount)
            };
          }
        }

        // Fetch product data
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(product => {
            addToRecentViews(productHandle, {
              title: product.title,
              url: `/products/${product.handle}`,
              image: product.images[0],
              price: product.variants[0]?.price,
              vendor: product.vendor,
              badges: badges,
              reviewData: reviewData
            });
          })
          .catch(console.error);
      }

      // Wait for Judge.me to load (it adds jdgm--done-setup class)
      document.addEventListener('DOMContentLoaded', function() {
        // Try immediately
        setTimeout(captureProductData, 500);
        // Also listen for Judge.me ready event
        document.addEventListener('jdgm.ready', captureProductData);
      });
    }
  }

  // Expose functions globally for sections to use
  window.ShopifyRecentViews = {
    add: addToRecentViews,
    get: getRecentViews,
    save: saveRecentViews
  };
})();
